import React from "react";
import { Phone, MessageCircle, MessageSquare } from "lucide-react";
import { businessInfo } from "../data/mockData";
import { trackContactClick } from "../lib/analytics";

const StickyMobileBar = () => {
  return (
    <div
      data-testid="sticky-mobile-bar"
      className="lg:hidden fixed bottom-0 inset-x-0 z-50 bg-white border-t border-slate-200 shadow-[0_-4px_12px_rgba(0,0,0,0.08)]"
    >
      <div className="grid grid-cols-3 gap-px bg-slate-200">
        <a
          href={businessInfo.phoneTel}
          onClick={() => trackContactClick("call", "sticky")}
          data-testid="sticky-call"
          className="flex flex-col items-center justify-center py-3 bg-brand-navy text-white font-semibold text-xs gap-1 active:bg-brand-navy-light"
        >
          <Phone className="h-5 w-5" />
          Call
        </a>
        <a
          href={businessInfo.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackContactClick("whatsapp", "sticky")}
          data-testid="sticky-whatsapp"
          className="flex flex-col items-center justify-center py-3 bg-brand-whatsapp text-white font-semibold text-xs gap-1 active:bg-brand-whatsapp-dark"
        >
          <MessageCircle className="h-5 w-5" />
          WhatsApp
        </a>
        <a
          href={businessInfo.sms}
          onClick={() => trackContactClick("text", "sticky")}
          data-testid="sticky-text"
          className="flex flex-col items-center justify-center py-3 bg-brand-blue text-white font-semibold text-xs gap-1 active:bg-brand-blue-light"
        >
          <MessageSquare className="h-5 w-5" />
          Text
        </a>
      </div>
    </div>
  );
};

export default StickyMobileBar;
